import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const LOGO_URL = "https://static.readdy.ai/image/ca9cac5a446d046780455544702b2fd6/8a4e7eea10d3bf25b57da0f4bc4bea03.png";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isHome = location.pathname === "/";
  const transparent = isHome && !scrolled;

  const navLinks = [
    { label: "Home", href: "/" },
    { label: "About Us", href: "/about" },
    { label: "Contact", href: "/contact" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        transparent
          ? "bg-transparent py-6"
          : "bg-stone-900/97 backdrop-blur-md py-3 border-b border-stone-800"
      }`}
    >
      <div className="max-w-7xl mx-auto px-8 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center cursor-pointer">
          <img
            src={LOGO_URL}
            alt="Havinar Homes"
            className="h-28 w-auto object-contain"
          />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`whitespace-nowrap text-sm font-medium tracking-widest uppercase transition-colors duration-300 ${
                transparent
                  ? "text-white/90 hover:text-amber-300"
                  : location.pathname === link.href
                  ? "text-amber-400"
                  : "text-stone-300 hover:text-amber-400"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            className={`whitespace-nowrap text-sm font-semibold tracking-widest uppercase px-6 py-2.5 rounded-full border transition-all duration-300 cursor-pointer ${
              transparent
                ? "border-white/70 text-white hover:bg-white hover:text-stone-900"
                : "border-amber-500 text-amber-400 hover:bg-amber-600 hover:text-white hover:border-amber-600"
            }`}
          >
            Get in Touch
          </Link>
        </nav>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden flex flex-col gap-1.5 cursor-pointer text-white"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`block w-6 h-0.5 bg-white transition-all duration-300 ${menuOpen ? "rotate-45 translate-y-2" : ""}`} />
          <span className={`block w-6 h-0.5 bg-white transition-all duration-300 ${menuOpen ? "opacity-0" : ""}`} />
          <span className={`block w-6 h-0.5 bg-white transition-all duration-300 ${menuOpen ? "-rotate-45 -translate-y-2" : ""}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-stone-900 border-t border-stone-800 px-8 py-6 flex flex-col gap-5">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              onClick={() => setMenuOpen(false)}
              className="text-stone-300 text-sm font-medium tracking-widest uppercase hover:text-amber-400 transition-colors cursor-pointer"
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            onClick={() => setMenuOpen(false)}
            className="whitespace-nowrap text-sm font-semibold tracking-widest uppercase px-6 py-2.5 rounded-full border border-amber-500 text-amber-400 hover:bg-amber-600 hover:text-white transition-all duration-300 text-center cursor-pointer"
          >
            Get in Touch
          </Link>
        </div>
      )}
    </header>
  );
}